import bbox from "@turf/bbox";

// Zooms the map so the feature (or FeatureCollection) fits on screen
export const zoomToFeature = (map, feature) => {
  if (!map || !feature) return;
  const [minX, minY, maxX, maxY] = bbox(feature);
  map.fitBounds(
    [
      [minX, minY],
      [maxX, maxY],
    ],
    { padding: 60, duration: 800 },
  );
};
